import React, { useContext } from "react"
import { PriceContext } from "@features/Price/PriceContext"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import * as styles from "./style.module.scss"

interface ValueProps {
  value: string | number
}

export const Value = ({ value }: ValueProps) => {
  const { calculator, range, text } = useContext(PriceContext)

  if (value in MODULE_MAP) {
    const key = MODULE_MAP[value as keyof typeof MODULE_MAP]
    const label = text.featuresText[key]

    return (
      <div className={styles.moduleValueWrapper}>
        <div className={styles.moduleValueText}>
          {text.featuresText.before}
          <br />
          <span className={styles.moduleValueAccent}>{label}</span>
        </div>

        <OverlayTrigger
          overlay={
            <Tooltip>
              <span>
                {text.featuresText.before}
                <br />
                <span className={styles.moduleValueAccent}>{label}</span>
              </span>
            </Tooltip>
          }
        >
          <span className={styles.mobileBulb}>{ICON}</span>
        </OverlayTrigger>
      </div>
    )
  }

  if (value in EMAIL_KEYS) {
    const planKey = EMAIL_KEYS[value as keyof typeof EMAIL_KEYS]
    const emails = calculator?.plans?.[planKey]?.[range]?.emails

    return <div>{emails?.toLocaleString() ?? "—"}</div>
  }

  return <div>{value}</div>
}

const ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#FC7C01" />
    <path
      d="M8.15841 13.4878C7.94293 13.2766 7.93946 12.9308 8.15068 12.7153L11.5922 9.20419C11.8034 8.98871 12.1492 8.98525 12.3647 9.19646L15.8758 12.638C16.0913 12.8492 16.0948 13.195 15.8836 13.4105C15.6723 13.6259 15.3265 13.6294 15.111 13.4182L12.3134 10.676C12.3134 10.676 12.1403 10.5018 12 10.5C11.8538 10.4981 11.6732 10.6824 11.6732 10.6824L8.93092 13.4801C8.71972 13.6956 8.37389 13.699 8.15841 13.4878Z"
      fill="white"
    />
  </svg>
)

const MODULE_MAP = {
  "#support-2-3": "support",
  "#leadbots-1-1": "leadBots",
  "#welcome-1-1": "welcome",
  "#messengers-1-1": "messengers",
  "#supportplus-1-1": "supportPlus",
  "#withoutBrand-1-1": "withoutBrand",
  "#scenario-1-1": "scenario",
  "#builder-1-1": "builder",
  "#extendedUpload-1-1": "extendedUpload",
  "#knowledge-1-2": "knowledge",
} as const

const EMAIL_KEYS = {
  "#emails-core": "core",
  "#emails-support": "support",
  "#emails-marketing": "marketing",
  "#marketing-expert": "marketingExpert",
} as const
